import moment from 'moment';
import React from 'react';
import styledComponent from '../../utils/styledComponent';
import SingleStopTable from './SingleStopTable';
import AldiPackingSlip from './AldiPackingSlip';
import fridgeIcon from '../../atoms/icons/Fridge.png';
import wholesaleIcon from '../../atoms/icons/Retail.png';
import Sun from '../../atoms/icons/Sun';
import Moon from '../../atoms/icons/Moon';
import StatusPill from '../../atoms/StatusPill';

const QRCode = require('qrcode.react');

const StyledDiv = styledComponent('div', {
  '& .header': {
    marginTop: '40px',
    fontSize: '26px',
    '& .line': {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    '& .titlePrettyName': {
      fontSize: '30px',
      fontWeight: 'bold',
      textAlign: 'center',
    },
    '& .itemNumber': {
      fontSize: '36px',
      fontWeight: 'normal',
      padding: '8px 32px',
      background: '#e5e5e5',
      marginLeft: '48px',
      letterSpacing: '3px',
    },
    '& .driverStop': {
      opacity: '0.54',
    },
    '& .driverRoute': {
      fontWeight: 'bold',
      fontSize: '28px',
    },
    '& .containerType': {
      opacity: '0.54',
    },
    '& .poNumber': {
      fontSize: '20px',
      fontWeight: 'bold',
      alignSelf: 'flex-end',
      paddingLeft: '40px',
    },
    '& .inline': {
      display: 'flex',
    },
  },
  '& .headerTable': {
    width: '100%',
    marginTop: '8px',
    borderCollapse: 'collapse',
    '& tr': {
      background: '#ffffff',
    },
    '& th': {
      padding: '4px 16px',
      border: '3px solid #000',
      fontSize: '16px',
      fontWeight: '900',
      textTransform: 'uppercase',
    },
    '& td': {
      fontSize: '24px',
      fontWeight: '500',
      width: '20%',
      border: '3px solid #000',
      textAlign: 'left',
      padding: '4px 4px 4px 16px',
      '&:nth-child(1)': {
        width: '18%',
        fontWeight: '900',
      },
      '&:nth-child(2)': {
        width: '18%',
        fontWeight: '900',
      },
      '&:nth-child(3)': {
        width: '18%',
        fontWeight: '900',
      },
      '&:nth-child(4)': {
        width: '18%',
        fontWeight: '900',
      },
      '&:nth-child(5)': {
        width: '16%',
        fontWeight: '900',
        borderRight: '3px solid #fff',
      },
      '&:nth-child(6)': {
        width: '14%',
        fontWeight: '900',
      },
    },
    '& .dayTimeCell': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      '& svg': {
        width: '32px',
        height: '32px',
        marginRight: '12px',
      },
    },
  },
  '& .main': {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    padding: '20px 0 6px 0',
    '& .packingSlipIndex': {
      display: 'flex',
      alignItems: 'flexStart',
      fontSize: '90px',
      fontWeight: 'bold',
      letterSpacing: '10px',
      textAlign: 'left',
      marginBottom: '16px',
    },
    '& .qrCodeWrapper': {
      width: '140px',
    },
    '& .additionalInfoWrapper': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '8px',
      minWidth: '350px',
    },
    '& .additionalInfoContentWithBug': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: '12px',
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'flex-end',
    },
    '& .additionalInfoContent': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '8px',
      flex: 1,
      minWidth: '250px',
    },
    '& .usdaBugImage': {
      width: '150px',
      height: 'auto',
      paddingLeft: '15px',
      flexShrink: 0,
    },
    '& .bestBeforeText': {
      fontWeight: 'bold',
      fontSize: '24px',
    },

    '& .additionalText': {
      fontSize: '20px',
    },
  },
  '& .description': {
    overflowWrap: 'anywhere',
    padding: '0 40px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .locationTypeWrapper img': {
      width: '32px',
      marginRight: '12px',
      opacity: '0.7',
    },
    '& .locationTypeSubWrapper': {
      flexDirection: 'column',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '12px 0px',
    },
    '& .locationId': {
      fontSize: '30px',
      fontWeight: 'bold',
    },
    '& .deliveryNotes': {
      fontSize: '20px',
    },
  },
  '& .lhDepartureDate': {
    fontSize: '24px',
    fontWeight: 'bold',
    textAlign: 'center',
    lineHeight: '140%',
    '& span': {
      fontSize: '28px',
    },
  },
  '& .dotted': {
    width: '50%',
    height: '1px',
    borderBottom: '1px dotted #000000',
    margin: '0 auto',
  },
  '& .underline': {
    textDecoration: 'underline',
  },
});

function renderSkuTable(skus, all_skus, date) {
  const skuList = Object.entries(skus).map(([sku, info]) => {
    // Access the shelfLife from all_skus using the SKU as the key
    const foundSku = all_skus.find((option) => option.id === sku);
    const shelfLife = foundSku.shelfLife || 0;

    // Use info.productionDate if it exists, otherwise use date
    const productionDate = info.productionDate || date;
    const expirationDate = moment(productionDate).add(shelfLife + 2, 'days');
    const formattedExpirationDate = expirationDate.format('MM-DD-YYYY');
    const lotCode = moment(productionDate).format('MMDDYYYY');

    return (
      <div key={sku}>
        <div>BEST BEFORE: {formattedExpirationDate}</div>
        <div>Lot Code: {lotCode}</div>
      </div>
    );
  });

  return <div>{skuList}</div>;
}

/* eslint-disable react/prop-types */
const RouteStop = ({
  routeStop,
  layout,
  items,
  fridgeLocationState,
  orderRegion,
  isAldiLocation,
  isColdChainSelected = false,
  toteSizes = {},
  isGrouped = false,
  groupIndex = 0,
}) => {
  const {
    location,
    date,
    subPackingSlipIndex,
    dropOffDate,
    type,
    qrCode,
    uniqueId,
    driver,
    stop,
    costco,
    containerType,
    data_ids,
    locationType,
    deliverySpecialNotes,
    linehaulFirstMile,
    linehaulMiddleMile,
    lhDepartureDate,
    poNumber,
    onlineDate,
    forks,
    spoons,
  } = routeStop;

  const twelveWeeksAfterOnlineDate = moment(onlineDate)
    .add(12, 'w')
    .startOf('day');
  const showPriority =
    onlineDate && twelveWeeksAfterOnlineDate.isAfter(moment().startOf('day'));

  const skusInPackingSlip = Object.keys(data_ids).filter((id) => id !== 'Box');
  const itemsWithFoodInfo =
    JSON.parse(localStorage.getItem('itemsWithFoodInfo'))?.items || [];

  // Get the first SKU from the packing slip
  const firstSku = skusInPackingSlip[0];

  // Find the corresponding item in itemsWithFoodInfo
  const currentItem = itemsWithFoodInfo.find((item) => item.id === firstSku);

  // Note: no `??` here — the CI toolchain does not transpile nullish
  // coalescing for jest, which runs on a Node version that can't parse it
  const currentItemPieces = currentItem
    ? data_ids[currentItem.id]?.value
    : undefined;
  const currentItemPiecesDisplay =
    currentItemPieces === undefined ? 'No Data' : currentItemPieces;

  let formattedDropOffDate = '';
  if (dropOffDate) {
    formattedDropOffDate = moment(dropOffDate).format('MMMM Do');
  } else if (date) {
    formattedDropOffDate = moment(date).format('MMMM Do').toUpperCase();
  }

  let formattedDayOfWeek = 'Date not specified';
  if (dropOffDate) {
    formattedDayOfWeek = moment(dropOffDate).format('dddd');
  } else if (date) {
    formattedDayOfWeek = moment(date).format('dddd');
  }

  const formattedSubPackingSlipIndex =
    subPackingSlipIndex &&
    `${subPackingSlipIndex}/${routeStop.totalSubPackingSlips}`;
  const isLastPackingSlipIndex =
    subPackingSlipIndex === routeStop.totalSubPackingSlips;

  const findRouteAmOrPm = (route) => {
    // Check if route is a valid string
    if (!route || typeof route !== 'string') {
      return '';
    }

    const parts = route.split('_');
    if (parts.includes('am')) {
      return 'AM';
    }
    if (parts.includes('pm')) {
      return 'PM';
    }
    return '';
  };

  const findRouteCity = (route) => {
    if (typeof route !== 'string') {
      return '—';
    }

    const parts = route.split('_');
    if (!Array.isArray(parts) || parts.length < 2) {
      return '—';
    }

    return parts[1].toUpperCase();
  };

  const formatTotalWeight = ({ oz, g }, count) => {
    const totalOunces = oz * count;
    const totalLb = (totalOunces / 16).toFixed(2);

    // Only calculate kg if g is provided and not 0
    const totalKg = g ? ((g * count) / 1000).toFixed(2) : null;

    return totalKg ? `${totalLb}lb/(${totalKg}kg)` : `${totalLb}lb`;
  };

  const locationSplit = location?.split('&')[0];
  const isHMSLocation = locationSplit.includes(
    'IL_HMS_OHARE__1000_BALMORAL_AVE',
  );
  const deltaLocations = [
    'CA_LA_DELTA_INFLIGHT_LAX__6701_W_IMPERIAL_HWY',
    'GA_DELTA_CHARTERS_ATL__ 2200_MH_JACKSON_SERVICE',
    'CA_SD_DELTA_CHARTERS_SAN__3870_HOUSTON_STREET',
  ];
  const isDeltaLocation = deltaLocations.some((loc) =>
    locationSplit.includes(loc),
  );
  const isAviLocation = locationSplit.includes('OH_AVI_RETAIL__2588_ELM_ROAD');
  // Home Delivery slips are keyed by the Cold Chain wholesale location
  const isColdChainLocation = locationSplit.includes(
    'IL_3PL_COLD_CHAIN__199_SHEPARD_AVE',
  );
  // Cold Chain home delivery slips reuse the AVI retailer slip format
  const isAviFormatLocation = isAviLocation || isColdChainLocation;

  // Home delivery slips carry no route or stop (they are a Cold Chain
  // handoff) — label them instead of showing the backend's
  // "Route data unavailable" / stop "0" placeholders
  let routeLabel = driver !== 'NOT_NEEDED' ? driver : '';
  if (isColdChainLocation) {
    routeLabel = 'Home Delivery';
  }
  const routeDayTime = findRouteAmOrPm(driver); // AM or PM

  // If this is an ALDI location, render the ALDI-specific packing slip
  if (isAldiLocation) {
    return (
      <AldiPackingSlip
        routeStop={routeStop}
        items={items}
        date={date}
        isGrouped={isGrouped}
        groupIndex={groupIndex}
      />
    );
  }

  return (
    <StyledDiv
      data-test="single-stops-table"
      key={`${location}${date}${subPackingSlipIndex}${dropOffDate}`}
    >
      <div className="dotted" />
      <div className="header">
        {(isDeltaLocation || isAviFormatLocation) && currentItem && (
          <div className="titlePrettyName">
            {currentItem.prettyName}{' '}
            <span className="itemNumber">{currentItem.itemNumber}</span>
          </div>
        )}
        <div className="line">
          <div className="date">{formattedDropOffDate}</div>
          <div>
            {stop !== 'NOT_NEEDED' && !isColdChainLocation && (
              <div className="driverStop">{stop}</div>
            )}
          </div>
        </div>
        <div className="line">
          <div className="inline">
            <div className="driverRoute">{routeLabel}</div>
            {poNumber && !isAviFormatLocation && (
              <div className="poNumber">PO# {poNumber}</div>
            )}
          </div>

          <div id="containerType" className="containerType">
            {containerType || 'Box'}
          </div>
        </div>
      </div>

      <table className="headerTable">
        <thead>
          <tr>
            <th>Linehaul-1</th>
            <th>Linehaul-2</th>
            <th>State</th>
            <th>City</th>
            <th colSpan="2">Route</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{linehaulFirstMile || '—'}</td>
            <td>{linehaulMiddleMile || '—'}</td>
            <td>
              {type === 'ALLOCATION' && (
                <div>{fridgeLocationState[locationSplit]}</div>
              )}
              {type === 'ORDER' && <div>{orderRegion}</div>}
            </td>
            <td>{findRouteCity(driver)}</td>
            <td>{formattedDayOfWeek}</td>
            <td>
              <div className="dayTimeCell">
                {routeDayTime === 'AM' && <Sun />}
                {routeDayTime === 'PM' && <Moon />}
                <span>{routeDayTime}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div className="main">
        <div>
          <div className="packingSlipIndex">{formattedSubPackingSlipIndex}</div>
          {isHMSLocation ||
            ((isDeltaLocation || isAviFormatLocation) && (
              <div className="line">
                <div className="bestBeforeText">
                  {renderSkuTable(data_ids, items, date)}
                </div>
              </div>
            ))}
        </div>

        {location !== 'Summary' && (
          <div className="qrCodeWrapper">
            {qrCode !== undefined && qrCode !== null ? (
              <QRCode size={140} value={qrCode} data-testid={qrCode} />
            ) : (
              <QRCode size={140} value={uniqueId} data-testid={uniqueId} />
            )}
          </div>
        )}
        <div className="additionalInfoWrapper">
          {isAviFormatLocation && currentItem && currentItem.usdaBugImage ? (
            <div className="additionalInfoContentWithBug">
              <img
                src={currentItem.usdaBugImage}
                alt="USDA Organic"
                className="usdaBugImage"
              />
              <div className="additionalInfoContent">
                <div className="line">
                  {isLastPackingSlipIndex && stop === '01' && (
                    <div className="star" />
                  )}
                </div>

                {lhDepartureDate &&
                  moment(lhDepartureDate).isValid() &&
                  dropOffDate &&
                  moment(dropOffDate).isValid() &&
                  moment(lhDepartureDate).isSameOrBefore(
                    moment(dropOffDate),
                  ) && (
                    <div className="line lhDepartureDate">
                      <div>{`Ships on ${moment(lhDepartureDate).format(
                        'dddd',
                      )}`}</div>
                      <div>{moment(lhDepartureDate).format('YYYY-MM-DD')}</div>
                    </div>
                  )}

                <div className="line">
                  {costco && <div className="textGreen">COSTCO</div>}
                </div>

                {currentItem && (
                  <div className="line">
                    <div className="additionalText">
                      <span className="underline">Allergens:</span>{' '}
                      {currentItem.foodInfo?.allergens || 'No information'}
                    </div>
                  </div>
                )}

                {currentItem && (
                  <div className="line">
                    <div className="additionalText">
                      <span className="underline">Net Weight:</span>{' '}
                      {!currentItem.netWeight.oz
                        ? 'No Data'
                        : formatTotalWeight(
                            currentItem.netWeight,
                            currentItemPiecesDisplay,
                          )}{' '}
                      <br />
                      {currentItem.netWeight.oz !== 0 && (
                        <>
                          {currentItemPiecesDisplay} pieces /{' '}
                          {currentItem.netWeight.oz}oz{' '}
                          {currentItem.netWeight.g
                            ? `(${currentItem.netWeight.g}g)`
                            : ''}
                        </>
                      )}
                    </div>
                  </div>
                )}
                {currentItem && (
                  <div className="line">
                    <div className="additionalText">
                      <span>Keep Refrigerated at or below 40° F</span>{' '}
                    </div>
                  </div>
                )}
                {showPriority && (
                  <StatusPill text="Priority: New Fridge" height="70px" />
                )}
              </div>
            </div>
          ) : (
            <div className="additionalInfoContent">
              <div className="line">
                {isLastPackingSlipIndex && stop === '01' && (
                  <div className="star" />
                )}
              </div>

              {lhDepartureDate &&
                moment(lhDepartureDate).isValid() &&
                dropOffDate &&
                moment(dropOffDate).isValid() &&
                moment(lhDepartureDate).isSameOrBefore(moment(dropOffDate)) && (
                  <div className="line lhDepartureDate">
                    <div>{`Ships on ${moment(lhDepartureDate).format(
                      'dddd',
                    )}`}</div>
                    <div>{moment(lhDepartureDate).format('YYYY-MM-DD')}</div>
                  </div>
                )}

              <div className="line">
                {costco && <div className="textGreen">COSTCO</div>}
              </div>

              {(isDeltaLocation || isAviFormatLocation) && currentItem && (
                <div className="line">
                  <div className="additionalText">
                    <span className="underline">Allergens:</span>{' '}
                    {currentItem.foodInfo?.allergens || 'No information'}
                  </div>
                </div>
              )}

              {(isDeltaLocation || isAviFormatLocation) && currentItem && (
                <div className="line">
                  <div className="additionalText">
                    <span className="underline">Net Weight:</span>{' '}
                    {!currentItem.netWeight.oz
                      ? 'No Data'
                      : formatTotalWeight(
                          currentItem.netWeight,
                          currentItemPiecesDisplay,
                        )}{' '}
                    <br />
                    {currentItem.netWeight.oz !== 0 && (
                      <>
                        {currentItemPiecesDisplay} pieces /{' '}
                        {currentItem.netWeight.oz}oz{' '}
                        {currentItem.netWeight.g
                          ? `(${currentItem.netWeight.g}g)`
                          : ''}
                      </>
                    )}
                  </div>
                </div>
              )}
              {isAviFormatLocation && currentItem && (
                <div className="line">
                  <div className="additionalText">
                    <span>Keep Refrigerated at or below 40° F</span>{' '}
                  </div>
                </div>
              )}
              {showPriority && (
                <StatusPill text="Priority: New Fridge" height="70px" />
              )}
            </div>
          )}
        </div>
      </div>

      <div className="description">
        <div className="locationTypeWrapper">
          {locationType === 'FRIDGE' && <img src={fridgeIcon} alt="Fridge" />}
          {locationType === 'WHOLESALE' && (
            <img src={wholesaleIcon} alt="Wholesale" />
          )}
        </div>
        <div className="locationTypeSubWrapper">
          <div className="locationId">{locationSplit}</div>
          {location.includes('INTERNAL') && (
            <div className="deliveryNotes">{deliverySpecialNotes}</div>
          )}
        </div>
      </div>

      <SingleStopTable
        layout={layout}
        items={items}
        psId={uniqueId}
        data={data_ids}
        location={locationSplit}
        showToteCounts={isColdChainSelected && location === 'Summary'}
        useDisplayNames={
          isColdChainLocation || (isColdChainSelected && location === 'Summary')
        }
        // wrapping is a home-delivery decision, deliberately separate from
        // useDisplayNames — a future display-name retailer keeps nowrap
        wrapItemNames={
          isColdChainLocation || (isColdChainSelected && location === 'Summary')
        }
        toteSizes={toteSizes}
        // forks={forks}
        // spoons={spoons}
      />
    </StyledDiv>
  );
};

export default RouteStop;
